import { Navigate, Outlet, lazyRouteComponent } from 'src/lib/routing';

import { RequireAuth } from 'containers/Auth/RequireAuth';
import { useConnectedClient } from 'context/ConnectedClientContext';

import type { FC, ReactNode } from 'react';
import type { RouteObject } from 'src/lib/routing';

const TeamsContainer = lazyRouteComponent(() => import('./TeamsContainer'), 'TeamsContainer');
const CreateTeam = lazyRouteComponent(() => import('./components/CreateTeam'), 'CreateTeam');

// Team creation is no longer self-serve — teams are provisioned by Askable staff via
// the admin platform. This keeps `/teams/create` from being reachable by URL now that
// the "Create new team" button is hidden from non-staff users in YourTeams.tsx.
const RequireAskableInternal: FC<{ children: ReactNode }> = ({ children }) => {
  const { details } = useConnectedClient();
  return details?.isAskableInternalStaff ? <>{children}</> : <Navigate to="/teams" replace />;
};

export const teamRoutes: RouteObject[] = [
  {
    path: 'teams',
    element: (
      <RequireAuth>
        <Outlet />
      </RequireAuth>
    ),
    children: [
      {
        path: 'create',
        element: (
          <RequireAskableInternal>
            <CreateTeam />
          </RequireAskableInternal>
        ),
      },
      {
        index: true,
        element: <TeamsContainer />,
      },
    ],
  },
];
